export default __webpack_public_path__ + "static/media/1.bb636c48.jpg";